// extracted by mini-css-extract-plugin
export default {"container":"CabinClassItemGroup_container__dte6m","radioText":"CabinClassItemGroup_radioText__fj0CQ"};